import { getInitialLocale } from "@/i18n/initialLocale";
import type { AppLocale } from "@/i18n/locales";
import { atom } from "jotai";

export const localeAtom = atom<AppLocale>(getInitialLocale());
